import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from 'src/app/services/authentication/auth-service';
import { JwtService } from 'src/app/services/jwt/jwt-service';
import { environment } from 'src/environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const jwtService = inject(JwtService);

  const token = jwtService.getToken();
  const request = req.url.startsWith(environment.HTTP);

  if (request) {
    const headers: Record<string, string> = {};
    if (token) headers['Authorization'] = `Bearer ${token}`;

    const country = jwtService.getCountry();
    if (country) headers['X-Country'] = country;

    req = req.clone({ setHeaders: headers });
  }

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        authService.clearLogout();
      } else if (err.status === 403) {
        authService.on403();
      } else if (err.status === 503) {
        authService.on503();
      }
      return throwError(() => err);
    })
  );
};
